const branding = {
  ENERGIC: 'energic',
  VOLTIE: 'voltie',
};

const mimeTypes = {
  PNG: 'image/png',
  JPG: 'image/jpg',
  JPEG: 'image/jpeg',
  MP4: 'video/mp4',
  PDF: 'application/pdf',
  MOV: 'video/quicktime',
};

const powerUnit = {
  A: 'Amps',
  KWH: 'kWh',
};

const desiredPowerOutputUnits = [
  {
    label: 'kW',
    value: 'W',
  },
  {
    label: 'Amps',
    value: 'A',
  },
];

const maxPowerOutputUnits = [
  {
    label: 'kW',
    value: 'kW',
  },

  {
    label: 'Amps',
    value: 'A',
  },
];

const connectorTypes = {
  energic: [
    {
      label: 'CCS1',
      value: 'CCS1',
    },
    {
      label: 'CCS2',
      value: 'CCS2',
    },
    {
      label: 'Type2',
      value: 'Type2',
    },
    {
      label: 'CHAdeMO',
      value: 'CHAdeMO',
    },
    {
      label: 'NACS',
      value: 'NACS',
    },
    {
      label: 'J1772',
      value: 'J1772',
    },
  ],
  custom: [
    {
      label: 'CCS1',
      value: 'CCS1',
    },
    {
      label: 'CCS2',
      value: 'CCS2',
    },
    {
      label: 'Type2',
      value: 'Type2',
    },
    {
      label: 'CHAdeMO',
      value: 'CHAdeMO',
    },
    {
      label: 'NACS',
      value: 'NACS',
    },
    {
      label: 'J1772',
      value: 'J1772',
    },
  ],
  voltie: [
    {
      label: 'CCS1',
      value: 'CCS1',
    },
    {
      label: 'CCS2',
      value: 'CCS2',
    },
    {
      label: 'CHAdeMO',
      value: 'CHAdeMO',
    },
    {
      label: 'NACS',
      value: 'NACS',
    },
    {
      label: 'J1772',
      value: 'J1772',
    },
  ],
};

const imageMimeTypes = [mimeTypes.JPG, mimeTypes.PNG, mimeTypes.JPEG];

const videoMimeTypes = [mimeTypes.MP4, mimeTypes.MOV];

const documentMimeTypes = [mimeTypes.PDF];

const filterType = {
  DATE: 'date',
  TEXT: 'text',
  CHECKBOX: 'checkbox',
  RADIO_BUTTON: 'radio-button',
  SELECT_FIELD: 'list',
  DATE_RANGE: 'dateRange',
  TIME_RANGE: 'timeRange',
  // MULTI_SELECT_FIELD: 'multi-select-field',
  MULTISELECT: 'multiSelect',
  ANGLE_BRACKETS: 'angleBrackets',
  ARRAY_OF_STRINGS: 'arrayOfString',
} as const; // Prevents additional modification

// Define the type based on filterType object
type FilterType = (typeof filterType)[keyof typeof filterType];

const freeScheduleLimitTypes = [
  {
    label: 'Day',
    value: 'perDay',
  },
  {
    label: 'Week',
    value: 'perWeek',
  },
  {
    label: 'Month',
    value: 'perMonth',
  },
  {
    label: 'Year',
    value: 'perYear',
  },
];

const deviceModelSeries = [
  {
    label: 'JuiceBox',
    value: 'JuiceBox',
  },
  {
    label: 'Nano Series',
    value: 'Nano Series',
  },
  {
    label: 'Wall Series',
    value: 'Wall Series',
  },
];

const chartTimePeriod: {
  label: string;
  value: 'last24hours' | 'last7days' | 'lastMonth' | 'last12months';
}[] = [
  {
    label: '24Hours',
    value: 'last24hours',
  },
  {
    label: '7Days',
    value: 'last7days',
  },
  {
    label: 'lastMonth',
    value: 'lastMonth',
  },
  {
    label: '12Months',
    value: 'last12months',
  },
];

const connectorStatus = {
  AVAILABLE: 'Available',
  PREPARING: 'Preparing',
  FINISHING: 'Finishing',
  CHARGING: 'Charging',
  SUSPENDED_EVSE: 'SuspendedEVSE',
  SUSPENDED_EV: 'SuspendedEV',
  RESERVED: 'Reserved',
  UNAVAILABLE: 'Unavailable',
  FAULTED: 'Faulted',
};

export {
  branding,
  powerUnit,
  mimeTypes,
  imageMimeTypes,
  videoMimeTypes,
  documentMimeTypes,
  filterType,
  FilterType,
  connectorTypes,
  maxPowerOutputUnits,
  desiredPowerOutputUnits,
  freeScheduleLimitTypes,
  deviceModelSeries,
  chartTimePeriod,
  connectorStatus,
};
